// import React, { useEffect, useState } from "react";
// import { useNavigate, Link } from "react-router-dom"; // ✅ Added Link
// import "./LatestJobs.css";
// import { FiExternalLink } from "react-icons/fi";

// const LatestJobs = () => {
//   const [jobs, setJobs] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
//     fetch(`${API_URL}/jobs`)
//       .then((res) => res.json())
//       .then((data) => {
//         console.log("Fetched Jobs:", data);
//         setJobs(data.reverse());
//       })
//       .catch((err) => {
//         console.error("Error fetching jobs:", err);
//       });
//   }, []);

//   return (
//     <div className="table-card">
//       <h3 className="table-title">Latest Jobs</h3>
//       <table className="styled-table">
//         <thead>
//           <tr>
//             <th>Job</th>
//             <th className="desktop-only">Details</th>
//             <th className="mobile-only"></th>
//           </tr>
//         </thead>
//         <tbody>
//           {jobs.slice(0, 10).map((job, index) => (
//             <tr key={index}>
//               <td>{job.JobTitle}</td>

//               {/* Desktop view: use Link */}
//               <td className="desktop-only">
//                 <Link to={`/job/${job._id}`}>
//                   View Details
//                 </Link>
//               </td>

//               {/* Mobile view: use Link with icon */}
//               <td className="mobile-only">
//                 <Link to={`/job/${job._id}`}>
//                   <FiExternalLink size={16} />
//                 </Link>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {jobs.length > 10 && (
//         <div style={{ textAlign: "right", marginTop: "1rem" }}>
//           <button className="see-all-btn" onClick={() => navigate("/all-jobs")}>
//             See All Jobs
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default LatestJobs;






import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom"; // ✅ Added Link
import "./LatestJobs.css";
// import { FiExternalLink } from "react-icons/fi";

const LatestJobs = () => {
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
    fetch(`${API_URL}/jobs`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched Jobs:", data);
        setJobs(data.reverse());
      })
      .catch((err) => {
        console.error("Error fetching jobs:", err);
      });
  }, []);

  return (
    <div className="table-card">
  <h3 className="table-title">Latest Jobs</h3>
  <table className="styled-table">
    <thead>
      <tr>
        <th>Job</th>
      </tr>
    </thead>
    <tbody>
      {jobs.slice(0, 15).map((job, index) => (
        <tr key={index}>
          <td style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span style={{ color: "#000", fontSize: "20px", lineHeight: "1" }}>•</span>
            <Link to={`/job/${job.slug}`} className="job-link" style={{
                    textDecoration: "none",
                    color: "#007bff",
                  }}>
            
              {job.JobTitle}
            </Link>
          </td>
        </tr>
      ))}
    </tbody>
  </table>

  {jobs.length > 15 && (
    <div style={{ textAlign: "right", marginTop: "1rem" }}>
      <button className="see-all-btn" onClick={() => navigate("/all-jobs")}>
        See All Jobs
      </button>
    </div>
  )}
</div>

  );
};

export default LatestJobs;
